import { InsightWidget } from '@/store/beneficiary-insights/types'

import { Empty } from './Empty'
import { InsightsDashboardLayout } from './Layout'

export function Dashboard({
  widgets,
  isLoading,
  editMode = false,
}: {
  widgets: InsightWidget[]
  isLoading: boolean
  editMode?: boolean
}) {
  if (isLoading) {
    return
  }

  if (widgets.length === 0) {
    return <Empty />
  }

  return <InsightsDashboardLayout widgets={widgets} editMode={editMode} />
}
